import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ResumeProvider } from "../contexts/ResumeContext";
import ResumeForm from "../ResumeForm";
import ResumePreview from "../ResumePreview";
import { Button } from "../ui/button";
import { ArrowLeft } from "lucide-react";
import { templateOptions } from "../../data/templateData";

const Editor = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();

  // Check if templateId exists in our template options
  const validTemplate = templateOptions.find(template => template.id === templateId);

  if (!templateId || !validTemplate) {
    navigate("/resume");
    return null;
  }

  return (
    <ResumeProvider templateType={templateId}>
      <div className="min-h-screen bg-background w-full">
        <div className="w-full mx-auto">
          <Button
            variant="ghost"
            onClick={() => navigate("/resume")}
            className="mb-4 ml-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Templates
          </Button>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 w-full p-4">
            {/* Left: Form - takes 2 columns on large screens (40% of space) */}
            <div className="lg:col-span-2 bg-white rounded-lg shadow-xl overflow-hidden p-6 space-y-6 hover:shadow-2xl transition-shadow duration-300 ease-in-out">
              <ResumeForm />
            </div>

            {/* Right: Preview - takes 3 columns on large screens (60% of space) */}
            <div className="lg:col-span-3 bg-white rounded-lg shadow-xl overflow-hidden p-6 space-y-6 hover:shadow-2xl transition-shadow duration-300 ease-in-out">
              <ResumePreview />
            </div>
          </div>
        </div>
      </div>
    </ResumeProvider>
  );
};

export default Editor;
